import React, { useState, useEffect } from 'react';
import arrayMove from 'array-move';
import { useQuery, useLazyQuery } from 'react-apollo';
import Box from '@material-ui/core/Box';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import FormGroup from '@material-ui/core/FormGroup';
import TextField from '@material-ui/core/TextField';
import Grid from '@material-ui/core/Grid';
import NativeSelect from '@material-ui/core/NativeSelect';
import Button from '@material-ui/core/Button';
import CardActions from '@material-ui/core/CardActions';
import DeleteIcon from '@material-ui/icons/Delete';
import {
  SortableContainer,
  SortableElement,
  SortableHandle,
} from 'react-sortable-hoc';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import DragIndicatorIcon from '@material-ui/icons/DragIndicator';
import ListItem from '@material-ui/core/ListItem';
import List from '@material-ui/core/List';
import ListItemText from '@material-ui/core/ListItemText';
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';
import IconButton from '@material-ui/core/IconButton';
import { GET_CURRICULA, GET_MODULES, GET_ALL_MODULES } from 'graphql/admin/curriculum';

import DateInput from 'components/common/DatePickerLabel';
import useSnack from 'hooks/useSnack';
import { useSelector } from 'react-redux';

const DragHandle = SortableHandle(() => (
  <ListItemIcon>
    <DragIndicatorIcon style={{ cursor: 'move' }} />
  </ListItemIcon>
));

const SortableItem = SortableElement(({ children, canEdit, ...props }) => (
  <ListItem ContainerComponent="div" {...props}>
    {canEdit && <DragHandle />}
    {children}
  </ListItem>
));

const SortableListContainer = SortableContainer(({ items, modules, onRemove, canEdit }) => (
  <List component="div" title="Exercises">
    {items.map((item, index) => {
      const mod = modules.find((m) => m.id === item.module);
      const ex = mod?.exercises.find((ex) => ex.id === item.exercise);
      return (
        <SortableItem divider disableGutters key={index} index={index} canEdit={canEdit}>
          <ListItemText
            primary={`${ex?.name} (duration ${ex?.duration} minutes)`}
            secondary={mod?.name}
          />
          {canEdit && (
            <ListItemSecondaryAction>
              <IconButton edge="end" onClick={() => onRemove(item)}>
                <DeleteIcon />
              </IconButton>
            </ListItemSecondaryAction>
          )}
        </SortableItem>
      );
    })}
  </List>
));



const ScheduleMilestoneItem = SortableElement(
  ({
    modules,
    data,
    milestones,
    milestone,
    onRemoveMilestone,
    onRemoveExercise,
    onMove,
    onAddExercise,
    onUpdateMilestone,
    classes,
    canEdit
  }) => {
    const curriculaResp = useQuery(GET_CURRICULA);
    const [curriculum, setCurriculum] = useState();
    const [module, setModule] = useState();
    const [exercise, setExercise] = useState();
    const snack = useSnack();



    //Total number of students exercise meetingCredit
    const circle_cc_total = data?.find((i) => i.credit_type === 'circle_cc')?.available || 0;
    let cc_total = data?.find((i) => i.credit_type === 'cc')?.available || 0;
    cc_total = cc_total + circle_cc_total;
    let hc_total = data?.find((i) => i.credit_type === 'hc')?.available || 0;
    const circle_hc_total = data?.find((i) => i.credit_type === 'circle_hc')?.available || 0;
    hc_total = hc_total + circle_hc_total;
    const fa_total = data?.find((i) => i.credit_type === 'fa')?.available || 0;
    const cssp_total = data?.find((i) => i.credit_type === 'css_profile')?.available || 0;
    const fafsaCss_total = data?.find((i) => i.credit_type === 'fafsa_css')?.available || 0;









    //Checking data of milestone exercise meetings used assigned by Coaches

    const totalMeetings = milestones.map(o => o.exercises.map(i => i.type)).reduce((acc, m) => acc.concat(m)).filter(Boolean).sort();
    const totalCcExercises = totalMeetings?.filter(x => x === 'cc' || x === 'circle_cc').length
    const totalHcExercises = totalMeetings?.filter(x => x === 'hc' || x === 'circle_hc').length
    const totalFaExercises = totalMeetings?.filter(x => x === 'fa').length
    const totalCssExercises = totalMeetings?.filter(x => x === 'css_profile').length
    const fafsaCssExercises = totalMeetings?.filter(x => x === 'fafsa_css').length





    //For testing total number of meeting credits and total used meeting by the students
    
    // useEffect(() => {
    //   console.log("this is cc_total", cc_total)
    //   console.log("this is totalCcExercises", totalCcExercises)

    //   console.log("this is hc_total", hc_total)
    //   console.log("this is totalHcExercises", totalHcExercises)

    //   console.log("this is fa_total", fa_total)
    //   console.log("this is totalFaExercises", totalFaExercises)

    //   console.log("this is cssp_total", cssp_total)
    //   console.log("this is totalCssExercises", totalCssExercises)

    //   console.log("this is fafsaCss_total", fafsaCss_total)
    //   console.log("this is fafsaCssExercises", fafsaCssExercises)
    // }, [])






    useEffect(() => {
      setModule();
      setExercise();
    }, [curriculum])
    const onSortEnd = ({ oldIndex, newIndex }) => {
      if (oldIndex === newIndex) return;
      const old = milestone.exercises[oldIndex];
      const _new = milestone.exercises[newIndex];
      old.order = newIndex;
      _new.order = oldIndex;
      milestone.exercises = arrayMove(milestone.exercises, oldIndex, newIndex);
      onMove(old, _new);
    };

    const onNameChange = (e) => {
      milestone.name = e.target.value;
      onUpdateMilestone(milestone);
    };

    const onDueDateChange = (val) => {
      milestone.due_date = val;
      onUpdateMilestone(milestone);
    }

    const onAdd = () => {
      onAddExercise(milestone, module, exercise);
      setExercise();
    }




    const meetingCreditsValidation = (meetingId) => {
      if (meetingId === 'cc' || meetingId === 'circle_cc') {
        if (totalCcExercises >= cc_total) {
          window.analytics.track('student exceeded meetings credit limit for this meeting')
          alert('student exceeded meetings credit limit for this meeting');
          // console.log('student exceeded meetings credit limit for this meeting');
        }
      }
      else if (meetingId === 'hc' || meetingId === 'circle_hc') {
        if (totalHcExercises >= hc_total) {
          window.analytics.track('student exceeded meetings credit limit for this meeting')
          alert('student exceeded meetings credit limit for this meeting');
          // console.log('student exceeded meetings credit limit for this meeting');

        }

      }
      else if (meetingId === 'fa') {
        if (totalFaExercises >= fa_total) {
          window.analytics.track('student exceeded meetings credit limit for this meeting');
          alert('student exceeded meetings credit limit for this meeting');
          // console.log('student exceeded meetings credit limit for this meeting');
        }
      }
      else if (meetingId === 'css_profile') {
        if (totalCssExercises >= cssp_total) {
          window.analytics.track('student exceeded meetings credit limit for this meeting')
          alert('student exceeded meetings credit limit for this meeting');
          // console.log('student exceeded meetings credit limit for this meeting');
        }
      }
      else if (meetingId === 'fafsa_css') {
        if (fafsaCssExercises >= fafsaCss_total) {
          window.analytics.track('student exceeded meetings credit limit for this meeting')
          alert('student exceeded meetings credit limit for this meeting');
          // console.log('student exceeded meetings credit limit for this meeting');
        }
      }

      else {
        return;
      }


    }

    function getMeetingTypeById(id) {
      for (let i=0; i<modules.length; i++) {
        for (let j=0; j<modules[i].exercises.length; j++) {
          if (modules[i].exercises[j].id === id) {
            return modules[i].exercises[j].meeting_type;
          }
        }
      }
    }




    const filteredModules = curriculum ? modules.filter(i => i.curriculum_id === curriculum) : [];

    return (
      <Card className={classes.card}>
        <CardContent>
          <Box display="flex" alignItems="center">
            {canEdit && <DragHandle />}
            <FormGroup style={{ flex: 1 }}>
              <TextField
                disabled={!canEdit}
                fullWidth
                value={milestone.name}
                onChange={onNameChange}
                margin={'normal'}
                placeholder="Milestone name"
                error={!milestone.name}
                helperText="Please enter milestone name"
              />
            </FormGroup>
            <Box ml={3}>
              <DateInput emptyLabel="Pick Due Date" value={milestone.due_date} onChange={onDueDateChange} />
            </Box>
          </Box>
          <SortableListContainer
            canEdit={canEdit}
            items={milestone.exercises}
            modules={modules}
            onRemove={(e) => onRemoveExercise(milestone, e)}
            onSortEnd={onSortEnd}
            useDragHandle={true}
            lockAxis="y"
          />
          {canEdit && (
            <div className={classes.addContainer}>
              <Grid container spacing={2}>
                <Grid item md={3}>
                  <NativeSelect
                    fullWidth
                    placeholder="Select Curriculum"
                    value={curriculum || ''}
                    onChange={(e) => setCurriculum(Number(e.target.value))}
                  >
                    <option value="" disabled selected>
                      Select Curriculum
                    </option>
                    {curriculaResp.data?.curricula.map((m) => (
                      <option value={m.id} key={m.id}>
                        {m.name}
                      </option>
                    ))}
                  </NativeSelect>
                </Grid>
                <Grid item md={3}>
                  <NativeSelect
                    fullWidth
                    placeholder="Select module"
                    value={module || ''}
                    onChange={(e) => setModule(Number(e.target.value))}
                  >
                    <option value="" disabled selected>
                      Select module
                    </option>
                    {filteredModules.map((m) => (
                      <option value={m.id} key={m.id}>
                        {m.name}
                      </option>
                    ))}
                  </NativeSelect>
                </Grid>
                <Grid item md={3}>
                  <NativeSelect
                    fullWidth
                    value={exercise || ''}
                    onChange={(e) => {
                      setExercise(Number(e.target.value));
                      meetingCreditsValidation(getMeetingTypeById(Number(e.target.value)));
                    }}
                  >
                    <option value="" disabled selected>
                      Select exercise
                    </option>
                    {module ? modules
                      .find((m) => m.id === module)
                      .exercises.filter((e) => {
                        if (e.type === 'meeting' || e.type === 'snapshot')
                          return true;
                        const usedInMilestone = milestones.find((m) =>
                          m.exercises?.find((ex) => ex.exercise === e.id),
                        );
                        if (usedInMilestone) return false;
                        const found = milestone.exercises?.find(
                          (i) => i.exercise === e.id,
                        );
                        return !found;
                      })
                      .map((m) => (
                        <option value={m.id} key={m.id}>
                          {m.name}
                        </option>
                      ))
                      : null}
                  </NativeSelect>
                </Grid>
                <Grid item md={3}>
                  <Button
                    fullWidth
                    disabled={!exercise}
                    color="primary"
                    onClick={onAdd}
                  >
                    Add exercise
                  </Button>
                </Grid>
              </Grid>
            </div>
          )}
        </CardContent>
        {canEdit && (
          <CardActions className={classes.cardFooter}>
            <Button
              startIcon={<DeleteIcon />}
              color="secondary"
              onClick={() => onRemoveMilestone(milestone)}
            >
              Remove milestone
            </Button>
          </CardActions>
        )}
      </Card>
    );
  },
);

export default ScheduleMilestoneItem;
